import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { ListItem } from '@mui/material';
import FrmDialogTest from './FrmDialogTest';
type Props = {};
const FrmDialogTest1: React.FC<Props> = () => {
    const [open, setOpen] = useState(false); // dialog開關
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    return (
        <div>
            <Button variant="outlined" onClick={handleOpen}>
                DialogTestOpen
            </Button>
            <Dialog fullScreen open={open}>
                <ListItem>
                    <FrmDialogTest />
                </ListItem>
                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
                </IconButton>
            </Dialog>
        </div>
    );
};

export default FrmDialogTest1;